function TableSearchBarItemWrapper({ children }) {
  return <div className="md:w-48 w-1/2 px-1 pb-2">{children}</div>;
}

export default TableSearchBarItemWrapper;
